// Packages and components
import React, { useEffect, useState } from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDImage from '@ui/Image/SHDImage';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDSelectable from '@ui/Selectable/SHDSelectable';
import SHDText from '@ui/Text/SHDText';

// Helpers and utlities
import { toTitleCase } from '@theme/utils/type';

// Types
import type { SportsSelectionProps } from './Onboarding.d';
import type { SportType } from '@theme/theme.d';
import type { BoxProps } from 'grommet';
import { analytics } from '@services/analytics';

const SportsSelection: React.FC<SportsSelectionProps> = ({
  onContinue,
  userId,
}) => {
  const rowProps: BoxProps = {
    direction: 'row',
    fill: 'horizontal',
    gap: '16px',
    justify: 'stretch',
    width: '100%',
    wrap: false,
  };

  useEffect(() => {
    analytics.track('Onboarding Started', {
      user_id: userId,
      type: 'Team Onboarding',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectedSport, setSelectedSport] = useState<SportType | null>(null);

  const getSportsNode = (sport: SportType) => {
    const sportTitle = toTitleCase(sport.replace('_', ' '));

    return (
      <SHDSelectable
        id={sport}
        isActive={selectedSport === sport}
        onSelected={(id) => setSelectedSport(id as SportType)}
      >
        <SHDImage
          alt={`${sportTitle} icon`}
          className="sports-selection-icon"
          color="black-alpha-70"
          isSquare={true}
          src={`/icons/${sport}.svg`}
          width={36}
        />
        <SHDText style="subhead-bold">{sportTitle}</SHDText>
      </SHDSelectable>
    );
  };

  return (
    <>
      <SHDModalContainer>
        <Box width="75%">
          <SHDHeading level={3}>What sport are you streaming for?</SHDHeading>
        </Box>
        <Box margin={{ top: 'xlarge' }} gap="small">
          <Box {...rowProps}>
            {getSportsNode('baseball')}
            {getSportsNode('basketball')}
          </Box>

          <Box {...rowProps}>
            {getSportsNode('hockey')}
            {getSportsNode('lacrosse')}
          </Box>

          <Box {...rowProps}>
            {getSportsNode('soccer')}
            {getSportsNode('softball')}
          </Box>

          <Box {...rowProps}>
            {getSportsNode('volleyball')}
            {getSportsNode('water_polo')}
          </Box>
        </Box>
      </SHDModalContainer>

      <SHDFooter>
        <SHDModalContainer>
          <SHDButton
            primary
            label="Continue"
            disabled={!selectedSport}
            onClick={() => onContinue(selectedSport as SportType)}
          />
        </SHDModalContainer>
      </SHDFooter>
    </>
  );
};

export default SportsSelection;
